/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AppLabInfo } from '../models/app-lab-info';
import { golabAppControllerGetGolabzAppList } from '../fn/golab-app/golab-app-controller-get-golabz-app-list';
import { GolabAppControllerGetGolabzAppList$Params } from '../fn/golab-app/golab-app-controller-get-golabz-app-list';
import { golabAppControllerGetGraaspAppList } from '../fn/golab-app/golab-app-controller-get-graasp-app-list';
import { GolabAppControllerGetGraaspAppList$Params } from '../fn/golab-app/golab-app-controller-get-graasp-app-list';
import { golabAppControllerGetNotSupportedAppList } from '../fn/golab-app/golab-app-controller-get-not-supported-app-list';
import { GolabAppControllerGetNotSupportedAppList$Params } from '../fn/golab-app/golab-app-controller-get-not-supported-app-list';
import { GolabAppDescription } from '../models/golab-app-description';

@Injectable({ providedIn: 'root' })
export class GolabAppService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `golabAppControllerGetGolabzAppList()` */
  static readonly GolabAppControllerGetGolabzAppListPath = '/golab-app/golabz-app-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `golabAppControllerGetGolabzAppList()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabAppControllerGetGolabzAppList$Response(params?: GolabAppControllerGetGolabzAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GolabAppDescription>>> {
    const obs = golabAppControllerGetGolabzAppList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `golabAppControllerGetGolabzAppList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabAppControllerGetGolabzAppList(params?: GolabAppControllerGetGolabzAppList$Params, context?: HttpContext): Observable<Array<GolabAppDescription>> {
    const resp = this.golabAppControllerGetGolabzAppList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<GolabAppDescription>>): Array<GolabAppDescription> => r.body)
    );
  }

  /** Path part for operation `golabAppControllerGetGraaspAppList()` */
  static readonly GolabAppControllerGetGraaspAppListPath = '/golab-app/graasp-app-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `golabAppControllerGetGraaspAppList()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabAppControllerGetGraaspAppList$Response(params?: GolabAppControllerGetGraaspAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GolabAppDescription>>> {
    const obs = golabAppControllerGetGraaspAppList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `golabAppControllerGetGraaspAppList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabAppControllerGetGraaspAppList(params?: GolabAppControllerGetGraaspAppList$Params, context?: HttpContext): Observable<Array<GolabAppDescription>> {
    const resp = this.golabAppControllerGetGraaspAppList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<GolabAppDescription>>): Array<GolabAppDescription> => r.body)
    );
  }

  /** Path part for operation `golabAppControllerGetNotSupportedAppList()` */
  static readonly GolabAppControllerGetNotSupportedAppListPath = '/golab-app/not-supported-app-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `golabAppControllerGetNotSupportedAppList()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabAppControllerGetNotSupportedAppList$Response(params?: GolabAppControllerGetNotSupportedAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppLabInfo>>> {
    const obs = golabAppControllerGetNotSupportedAppList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `golabAppControllerGetNotSupportedAppList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  golabAppControllerGetNotSupportedAppList(params?: GolabAppControllerGetNotSupportedAppList$Params, context?: HttpContext): Observable<Array<AppLabInfo>> {
    const resp = this.golabAppControllerGetNotSupportedAppList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AppLabInfo>>): Array<AppLabInfo> => r.body)
    );
  }

}
